import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";
import autosize from "autosize";

// Connects to data-controller="application"
export default class extends Controller {
  connect() {
    // fix adminlte with turbo
    // $.AdminLTE.Layout._jQueryInterface.call($("body"));
    document.dispatchEvent(new Event("init-AdminLTE"));

    // show tooltips
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
    );

    // selecionar a aba e colocar na url
    let hash = window.location.hash;
    hash &&
      $('ul.nav a[href="' + hash + '"]').tab("show") &&
      $('ul.nav button[data-bs-target="' + hash + '"]').tab("show");

    $(".nav-pills a").on("click", function (e) {
      $(this).tab("show");
      history.pushState({}, "", this.hash);
    });

    $(".nav-click").on("click", function (e) {
      e.preventDefault();
      $('a[href="' + $(this).attr("data-target") + '"]').tab("show");
    });

    // 🆕 Auto resize em todos os textareas visíveis
    autosize(document.querySelectorAll("textarea"));
  }
}
